import styled from 'styled-components';

export const StyledFloatingWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-grow: 1;
`;

export const StyledFloatingArea = styled.section`
  //position: absolute;
  left: calc(var(--side-padding) * -1);
  top: 0;
  bottom: 0;
  height: 100%;
  z-index: 9;
  display: flex;
  gap: 24px;
  flex-direction: column;

  article:nth-child(2) {
    flex-grow: 1;

    & > div:nth-child(1) {
      font-size: 24px;
      opacity: 0.7;
    }
  }

  article {
    display: flex;
    flex-direction: column;
    flex-grow: 10;

    & > div {
      position: relative;
      flex-grow: 1;
    }

    & > div:nth-child(1) {
      font-size: 18px;
      opacity: 0.6;
    }

    & > div:nth-child(2) {
      font-size: 24px;
      opacity: 0.7;
    }

    & > div:nth-child(3) {
      font-size: 32px;
      opacity: 0.8;
    }

    & > div:nth-child(4) {
      font-size: 48px;
      opacity: 0.9;
    }

    & > div:nth-child(5) {
      font-size: 64px;
    }

    font-size: 32px;
  }
`;
